export enum OrderPivotReportEnum {
  closedOrderPivotReport = 'ClosedOrderPivotReport',
  openOrderPivotReport = 'OpenOrderPivotReport',
  orderWithProductsPivotReport = 'OrderWithProductsPivotReport',
  orderPivotReport = 'OrderPivotReport',
  customerPivotReport = 'CustomerPivotReport',
  inventoryPivotReport = 'InventoryPivotReport',
  productPivotReport = 'ProductPivotReport',
  inventoryBySerialNumberPivotReport = 'inventoryBySerialNumberPivotReport',
}
